import React from 'react';
import ModalsContainer from '../../Componant/UiKits/Modals';

const Modals = () => {
  return (
    <div className='page-body'>
      <ModalsContainer />
    </div>
  );
};

export default Modals;
